// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog_blog__1uhap","blog-text":"Blog_blog-text__3Ez8v"};